import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { Loading } from '@/components/loaders';
import { WhatsappBusinessOnboardingBlock } from '@/features/campaigns/v2/components/WhatsappBusinessOnboardingBlock';
import { useWhatsappChannelConnector } from '@/features/connectors/whatsapp';
import RouteConstants from '@/features/router/RouteConstants';
import { WhatsappInboxPanes } from '@/features/whatsappInbox/components/WhatsappInboxPanes';
import { Button } from '@/lib';
import { COMUNI_TABS_ITEM } from '../comuni-helper';

/** Comuni Inbox tab: selection stays on `/comuni?tab=inbox&conversationId=…`. */
export const ComuniInboxTab: FC = () => {
  const { t } = useTranslation('whatsappInbox');
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const conversationId = searchParams.get('conversationId') ?? undefined;
  const { isLoading, businessInstanceId, needsOnboarding, onboarding } = useWhatsappChannelConnector();
  const ready = !isLoading && !!businessInstanceId && !needsOnboarding;

  const handleSelect = (id: string) => {
    const next = new URLSearchParams();
    next.set('tab', COMUNI_TABS_ITEM.INBOX);
    next.set('conversationId', id);
    history.push(`${RouteConstants.comuni}?${next.toString()}`);
  };

  const handleBack = () => {
    const next = new URLSearchParams();
    next.set('tab', COMUNI_TABS_ITEM.INBOX);
    history.push(`${RouteConstants.comuni}?${next.toString()}`);
  };

  if (isLoading) {
    return <Loading />;
  }

  if (!businessInstanceId) {
    return (
      <div className='space-y-3 rounded-xl border border-primary-border bg-white-100 p-6'>
        <p className='text-primary-900'>{t('notConnected')}</p>
        <Button intent='secondary' onClick={() => history.push(RouteConstants.destinations)}>
          {t('goToDestinations')}
        </Button>
      </div>
    );
  }

  if (needsOnboarding) {
    return <WhatsappBusinessOnboardingBlock onboardingUrl={onboarding?.onboardingUrl} />;
  }

  return <WhatsappInboxPanes selectedId={conversationId} onSelect={handleSelect} onBack={handleBack} skip={!ready} />;
};
